import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  errorText: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    color: '#F00',
  },
  inputContainer: {
    width: '60%',
    height: '50%',
    alignSelf: 'center',
    borderRadius: 28,
    fontSize: 14,
    padding: 10,
    borderWidth: 1,
    marginTop: '1%',
  },
  inputTextContainer: {
    width: '60%',
    height: '20%',
    alignSelf: 'center',
    borderRadius: 28,
    borderWidth: 1,
    marginTop: '2%',
    color: '#979797',
    paddingLeft: 10,
    fontSize: 14,
    marginBottom: '10%',
  },
  input: {
    width: '30%',
    height: '50%',
    color: '#979797',
    paddingLeft: 10,
    fontSize: 16,
    borderWidth: 0,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  modalBtnContainer: {
    flex: 0.3,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  confirmBtnStyle: {
    backgroundColor: '#FFFFFF',
    height: '65%',
  },
  fullHeight: {
    height: '100%',
  },
  confirmBtnText: {
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    textAlign: 'center',
  },
  cancelBtnStyle: {
    backgroundColor: '#FFFFFF',
    height: '65%',
  },
  cancelBtnText: {
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    textAlign: 'center',
  },
});
